"use client"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
// Remove: import Head from "next/head"
import { pageStyles } from "./styles"
import Navigation from "./navigation"
import About from "./about2"
import Experience from "./experience"
import Education from "./education"
import Skills from "./skill2"
import Testimonials from "./testtimonials2"
import ProjectsSection from "../client/ProjectsSection"
import { decryptId } from "../../utils/crypto";

export default function Home({ toggleSidebar }) {
  const [profile, setProfile] = useState(null);
  const { userId } = useParams();
  const decryptedUserId = decryptId(userId);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/profile/${decryptedUserId}`);
        const data = response.data
          ? {
              ...response.data,
              personal_image: response.data.personal_image
                ? decodeImage(response.data.personal_image)
                : "",
              transcripts: [
                response.data.transcript_upload1,
                response.data.transcript_upload2,
                response.data.transcript_upload3,
                response.data.transcript_upload4,
                response.data.transcript_upload5,
              ]
                .filter((transcript) => transcript !== null)
                .map(decodeImage),
            }
          : null;
        setProfile(data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    fetchProfile();
  }, []);

  const decodeImage = (base64String) => {
    const format = base64String.startsWith("/") ? "png" : "jpg";
    return `data:image/${format};base64,${base64String}`;
  };
  useEffect(() => {
    // Load Font Awesome
    const script = document.createElement("script")
    script.src = "https://use.fontawesome.com/releases/v6.3.0/js/all.js"
    script.crossOrigin = "anonymous"
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  const mainStyle = {
    ...pageStyles.main,
    ...(typeof window !== "undefined" && window.innerWidth >= 992 ? pageStyles.mainLg : {}),
  }
  const flexContainerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  zIndex: 10,
}

  return (
    <>
      {/* Remove <Head> ... </Head> */}
      <main style={{ ...mainStyle, width: "100%", backgroundColor: "#f7e6dc" }}>
        <Navigation toggleSidebar={toggleSidebar} profile={profile} />
        <div style={{ backgroundColor: "#f7e6dc" }}>
          <About profile={profile} />
          <hr style={{ margin: 0, borderTop: "1px solid rgba(0, 0, 0, 0.1)" }} />
          <Experience profile={profile} />
          <hr style={{ margin: 0, borderTop: "1px solid rgba(0, 0, 0, 0.1)" }} />
          <Education profile={profile} />
          <hr style={{ margin: 0, borderTop: "1px solid rgba(0, 0, 0, 0.1)" }} />
          <Skills profile={profile}/>
          <hr style={{ margin: 0, borderTop: "1px solid rgba(0, 0, 0, 0.1)" }} />
          <div style={flexContainerStyle}>
            <ProjectsSection userId={decryptedUserId} />
          </div>
          <hr style={{ margin: 0, borderTop: "1px solid rgba(0, 0, 0, 0.1)" }} />
          <Testimonials  profile={profile} />
        </div>
      </main>
    </>
  )
}
